import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=4b99856b&scoped=true&lang=pug&"
import script from "./Chats.vue?vue&type=script&lang=js&"
export * from "./Chats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99856b",
  null
  
)

export default component.exports